import { allAvailableEventTypes } from 'src/consumer/constants'
import { getDurationOptions } from 'src/mentor/components/MentorEventsPage/MentorEventsPageStyles'
import {
  GenericModalHeadlineLevelTwo,
  StyledInputSelect,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'

export default function DurationAndBuffers({
  basicEventObject,
  setBasicEventObject,
  isCustomTimeChosen,
  setIsCustomTimeChosen,
  isDisabled = false,
}) {
  if (basicEventObject?.type === allAvailableEventTypes?.webinar) {
    return null
  }

  return (
    <>
      <div>
        <GenericModalHeadlineLevelTwo>
          Duration(Choose from options or enter)
        </GenericModalHeadlineLevelTwo>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
          <div>
            <input
              type="radio"
              id="selection"
              checked={!isCustomTimeChosen}
              disabled={isDisabled}
              onChange={() => {
                setIsCustomTimeChosen(false)
                setBasicEventObject((prev) => ({ ...prev, durationInMins: 30 }))
              }}
            />
            <label style={{ marginLeft: '2px' }} htmlFor="selection">
              Selection
            </label>
          </div>

          <div>
            <input
              type="radio"
              id="customTime"
              disabled={isDisabled}
              checked={isCustomTimeChosen}
              onChange={() => {
                setIsCustomTimeChosen(true)
              }}
            />
            <label style={{ marginLeft: '5px' }} htmlFor="customTime">
              Custom Time
            </label>
          </div>
        </div>
        <div>
          {!isCustomTimeChosen && (
            <StyledInputSelect
              value={basicEventObject?.durationInMins?.toString()}
              disabled={isDisabled}
              onChange={(e) =>
                setBasicEventObject((prev) => ({ ...prev, durationInMins: e.target.value }))
              }
            >
              {getDurationOptions()}
            </StyledInputSelect>
          )}
          {isCustomTimeChosen && (
            <div>
              <input
                style={{ border: '1px solid #B2B2B2', borderRadius: '8px' }}
                type="number"
                disabled={isDisabled}
                value={basicEventObject?.durationInMins}
                onChange={(e) =>
                  setBasicEventObject((prev) => ({ ...prev, durationInMins: e.target.value }))
                }
              />
              <span>mins</span>
            </div>
          )}
        </div>
      </div>

      <div>
        <GenericModalHeadlineLevelTwo>Buffer Time before event</GenericModalHeadlineLevelTwo>
        <StyledInputSelect
          value={basicEventObject?.preBufferMins}
          disabled={isDisabled}
          onChange={(e) =>
            setBasicEventObject((prev) => ({ ...prev, preBufferMins: e.target.value }))
          }
        >
          <option value={0}>0 mins</option>
          <option value={5}>5 mins</option>
          <option value={10}>10 mins</option>
          <option value={15}>15 mins</option>
        </StyledInputSelect>
      </div>

      <div>
        <GenericModalHeadlineLevelTwo>Buffer Time after event</GenericModalHeadlineLevelTwo>
        <StyledInputSelect
          value={basicEventObject?.postBufferMins}
          disabled={isDisabled}
          onChange={(e) =>
            setBasicEventObject((prev) => ({ ...prev, postBufferMins: e.target.value }))
          }
        >
          <option value={0}>0 mins</option>
          <option value={5}>5 mins</option>
          <option value={10}>10 mins</option>
          <option value={15}>15 mins</option>
        </StyledInputSelect>
      </div>
    </>
  )
}
